"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.StandardAppBar = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Styling = require("@fluentui/react/lib/Styling");

var _SearchBox = require("@fluentui/react/lib/components/SearchBox");

var _Icon = require("@fluentui/react/lib/Icon");

var _Panel = require("@fluentui/react/lib/Panel");

var _Persona = require("@fluentui/react/lib/Persona");

var _withResponsiveMode = require("@fluentui/react/lib/utilities/decorators/withResponsiveMode");

var React = _interopRequireWildcard(require("react"));

var _AppBar = require("../../AppBar");

var _WafflePanel = require("../../WafflePanel");

var _ExtendedSearchBox = require("../Search/ExtendedSearchBox");

var _StandardAppBar = require("./StandardAppBar.classNames");

var StandardAppBar = function StandardAppBar(props) {
  var appSuiteItems = props.appSuiteItems,
      appTitle = props.appTitle,
      appTitleUrl = props.appTitleUrl,
      backButtonLabel = props.backButtonLabel,
      enableExtendedSearch = props.enableExtendedSearch,
      executeSearchLabel = props.executeSearchLabel,
      filterItems = props.filterItems,
      flagsLabel = props.flagsLabel,
      flagsVisible = props.flagsVisible,
      helpLabel = props.helpLabel,
      helpVisible = props.helpVisible,
      isFlagsOpen = props.isFlagsOpen,
      isHelpOpen = props.isHelpOpen,
      isMeControlOpen = props.isMeControlOpen,
      isNavOpen = props.isNavOpen,
      isNotificationPanelOpen = props.isNotificationPanelOpen,
      isOptionsOpen = props.isOptionsOpen,
      isTenantPickerOpen = props.isTenantPickerOpen,
      meControlLabel = props.meControlLabel,
      meControlVisible = props.meControlVisible,
      myAvatarUrl = props.myAvatarUrl,
      navButtonLabel = props.navButtonLabel,
      navVisible = props.navVisible,
      notificationsLabel = props.notificationsLabel,
      notificationsVisible = props.notificationsVisible,
      optionsLabel = props.optionsLabel,
      optionsVisible = props.optionsVisible,
      personaPills = props.personaPills,
      searchContext = props.searchContext,
      searchPlaceholderText = props.searchPlaceholderText,
      searchVisible = props.searchVisible,
      selectedFilterKey = props.selectedFilterKey,
      selectedSuggestionIndex = props.selectedSuggestionIndex,
      showFiltersIcon = props.showFiltersIcon,
      showFiltersMenu = props.showFiltersMenu,
      showSearchButtonLabel = props.showSearchButtonLabel,
      tenantLogoUrl = props.tenantLogoUrl,
      tenantName = props.tenantName,
      tenantPickerLabel = props.tenantPickerLabel,
      tenantPickerVisible = props.tenantPickerVisible,
      titleVisible = props.titleVisible,
      waffleHeaderText = props.waffleHeaderText,
      waffleLabel = props.waffleLabel,
      waffleVisible = props.waffleVisible,
      addKeywordSuggestion = props.addKeywordSuggestion,
      onFlagsClick = props.onFlagsClick,
      onHelpClick = props.onHelpClick,
      onMeClick = props.onMeClick,
      onNotificationPanelClick = props.onNotificationPanelClick,
      onOptionsClick = props.onOptionsClick,
      onTenantPickerClick = props.onTenantPickerClick,
      onToggleMenu = props.onToggleMenu,
      selectSuggestionByIndex = props.selectSuggestionByIndex,
      setSearchTextForSuggestion = props.setSearchTextForSuggestion,
      setSelectedSuggestionIndex = props.setSelectedSuggestionIndex,
      toggleSaveSearch = props.toggleSaveSearch;
  var theme = props.theme || (0, _Styling.getTheme)();

  var _useState = (0, React.useState)({
    isWaffleOpen: false,
    compactSearch: false,
    isFocusInSearch: false
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, React.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selfAppSuiteItems = _useState4[0],
      setSelfAppSuiteItems = _useState4[1];

  var setAppSuiteItems = (0, React.useCallback)(function (nextProps) {
    if (nextProps.appSuiteItems !== undefined && nextProps.appSuiteItems.length > 0) {
      setSelfAppSuiteItems({
        items: nextProps.appSuiteItems
      });
    } else {
      setSelfAppSuiteItems(undefined);
    }
  }, [setSelfAppSuiteItems]);
  (0, React.useEffect)(function () {
    setAppSuiteItems(props);
  }, []);
  var modal = state.compactSearch;
  var titleHidden = state.compactSearch || titleVisible === false;
  var responsiveMode = props.responsiveMode;

  if (responsiveMode === undefined) {
    responsiveMode = _withResponsiveMode.ResponsiveMode.large;
  }

  var hideSearch = searchVisible !== true || responsiveMode <= _withResponsiveMode.ResponsiveMode.large && !state.compactSearch;

  var _isDefaultFilterSelected = (0, React.useCallback)(function () {
    if (props.selectedFilterKey === undefined || props.filterItems === undefined || props.filterItems.length === 0) {
      return true;
    }

    return props.filterItems[0].key === props.selectedFilterKey;
  }, [props.selectedFilterKey, props.filterItems]);

  var _hasSearchTerm = (0, React.useCallback)(function () {
    var searchTerm = props.searchTerm;
    return searchTerm !== undefined && (0, _trim.default)(searchTerm).call(searchTerm).length > 0;
  }, [props.searchTerm]);

  var _isSearchBoxExpanded = (0, React.useCallback)(function () {
    return state.isFocusInSearch || props.showFiltersMenu || !_isDefaultFilterSelected() || _hasSearchTerm() || props.personaPills !== undefined && props.personaPills.length > 0;
  }, [_isDefaultFilterSelected, _hasSearchTerm, props.showFiltersMenu, state.isFocusInSearch, props.personaPills]);

  var isSearchBoxExpanded = _isSearchBoxExpanded();

  var _getClassNames = (0, _StandardAppBar.getClassNames)(theme),
      title = _getClassNames.title,
      titleSmall = _getClassNames.titleSmall,
      search = _getClassNames.search,
      inSearch = _getClassNames.inSearch,
      extendedSearch = _getClassNames.extendedSearch,
      modalSearch = _getClassNames.modalSearch,
      section = _getClassNames.section,
      overflow = _getClassNames.overflow,
      tenantLogo = _getClassNames.tenantLogo;

  var _onWaffleClick = (0, React.useCallback)(function () {
    setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
      isWaffleOpen: !state.isWaffleOpen
    }));
  }, [state, setState]);

  var _onSearchChange = (0, React.useCallback)(function (_, searchTerm) {
    var _props$onSearchChange, _props$searchContext;

    (_props$onSearchChange = props.onSearchChange) === null || _props$onSearchChange === void 0 ? void 0 : _props$onSearchChange.call(props, (_props$searchContext = props.searchContext) !== null && _props$searchContext !== void 0 ? _props$searchContext : '', searchTerm !== null && searchTerm !== void 0 ? searchTerm : '');
  }, [props.onSearchChange, props.searchContext]);

  var _onExtendedSearchChange = (0, React.useCallback)(function (searchTerm) {
    var _props$onSearchChange2, _props$searchContext2;

    (_props$onSearchChange2 = props.onSearchChange) === null || _props$onSearchChange2 === void 0 ? void 0 : _props$onSearchChange2.call(props, (_props$searchContext2 = props.searchContext) !== null && _props$searchContext2 !== void 0 ? _props$searchContext2 : '', searchTerm !== null && searchTerm !== void 0 ? searchTerm : '');
  }, [props.onSearchChange, props.searchContext]);

  var _goBack = (0, React.useCallback)(function () {
    setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
      isFocusInSearch: false,
      compactSearch: false
    }));
  }, [setState, state]);

  var _goSearchBack = (0, React.useCallback)(function () {
    if (props.goBack) {
      var _props$searchContext3;

      props.goBack((_props$searchContext3 = props.searchContext) !== null && _props$searchContext3 !== void 0 ? _props$searchContext3 : '');
    }

    _goBack();
  }, [props.goBack, _goBack]);

  var _onSearchBlurred = (0, React.useCallback)(function () {
    setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
      compactSearch: false,
      isFocusInSearch: false
    }));
  }, [setState, state]);

  var _showSearch = (0, React.useCallback)(function () {
    setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
      compactSearch: true,
      isFocusInSearch: true
    }));
  }, [state, setState]);

  var _onSearchFocused = (0, React.useCallback)(function () {
    setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
      isFocusInSearch: true
    }));
  }, [state, setState]);

  var _onSearch = (0, React.useCallback)(function (actionSource) {
    var _props$onSearch, _props$searchContext4, _props$searchTerm;

    (_props$onSearch = props.onSearch) === null || _props$onSearch === void 0 ? void 0 : _props$onSearch.call(props, (_props$searchContext4 = props.searchContext) !== null && _props$searchContext4 !== void 0 ? _props$searchContext4 : '', (_props$searchTerm = props.searchTerm) !== null && _props$searchTerm !== void 0 ? _props$searchTerm : '', actionSource, props.personaPills);
  }, [props.onSearch, props.searchContext, props.searchTerm, props.personaPills]);

  var _getOverflowItems = (0, React.useCallback)(function () {
    var meControlLabel = props.meControlLabel,
        onMeClick = props.onMeClick,
        optionsVisible = props.optionsVisible,
        optionsLabel = props.optionsLabel,
        onOptionsClick = props.onOptionsClick,
        helpVisible = props.helpVisible,
        helpLabel = props.helpLabel,
        onHelpClick = props.onHelpClick,
        notificationsVisible = props.notificationsVisible,
        notificationsLabel = props.notificationsLabel,
        tenantPickerVisible = props.tenantPickerVisible,
        tenantPickerLabel = props.tenantPickerLabel,
        onTenantPickerClick = props.onTenantPickerClick,
        onNotificationPanelClick = props.onNotificationPanelClick,
        waffleLabel = props.waffleLabel,
        waffleVisible = props.waffleVisible,
        flagsVisible = props.flagsVisible,
        flagsLabel = props.flagsLabel,
        onFlagsClick = props.onFlagsClick;
    var items = [];

    if (waffleVisible && waffleLabel) {
      items.push({
        key: 'apps',
        name: waffleLabel,
        icon: 'WaffleOffice365',
        onClick: _onWaffleClick
      });
    }

    if (optionsVisible && optionsLabel) {
      items.push({
        key: 'options',
        name: optionsLabel,
        icon: 'Settings',
        onClick: onOptionsClick
      });
    }

    if (helpVisible && helpLabel) {
      items.push({
        key: 'help',
        name: helpLabel,
        icon: 'Help',
        onClick: onHelpClick
      });
    }

    if (notificationsVisible && notificationsLabel) {
      items.push({
        key: 'notifications',
        name: notificationsLabel,
        icon: 'Ringer',
        onClick: onNotificationPanelClick
      });
    }

    if (tenantPickerVisible && tenantPickerLabel) {
      items.push({
        key: 'tenant-picker',
        name: tenantPickerLabel,
        icon: 'Org',
        onClick: onTenantPickerClick
      });
    }

    if (flagsVisible && flagsLabel) {
      items.push({
        key: 'flags',
        name: flagsLabel,
        icon: 'Flag',
        onClick: onFlagsClick
      });
    }

    if (meControlLabel) {
      items.push({
        key: 'meControl',
        name: meControlLabel,
        icon: 'Contact',
        onClick: onMeClick
      });
    }

    return items;
  }, [props, _onWaffleClick]);

  var _onWaffleDismiss = (0, React.useCallback)(function () {
    setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
      isWaffleOpen: false
    }));
  }, [state, setState]);

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _react.css)('ms-AppBarContainer', enableExtendedSearch && isSearchBoxExpanded && inSearch),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_AppBar.AppBar, {
      theme: theme,
      children: [waffleVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        className: "app-WaffleButton",
        hidden: modal || responsiveMode < _withResponsiveMode.ResponsiveMode.xLarge,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
          theme: theme,
          checked: state.isWaffleOpen,
          primary: true,
          onClick: _onWaffleClick,
          title: waffleLabel,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            iconName: 'WaffleOffice365'
          })
        })
      }) : null, navVisible !== false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        hidden: modal || responsiveMode >= _withResponsiveMode.ResponsiveMode.xLarge,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
          theme: theme,
          title: navButtonLabel,
          checked: isNavOpen,
          primary: true,
          onClick: onToggleMenu,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            iconName: 'GlobalNavButton'
          })
        })
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        hidden: enableExtendedSearch || !modal,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
          theme: theme,
          title: backButtonLabel,
          "data-automation-id": "backButton",
          onClick: _goBack,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            iconName: 'Back'
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        hidden: !!(modal || !tenantLogoUrl || responsiveMode <= _withResponsiveMode.ResponsiveMode.medium),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: tenantLogo,
          src: tenantLogoUrl,
          title: tenantName
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        hidden: !!(modal || tenantLogoUrl || !tenantName || responsiveMode <= _withResponsiveMode.ResponsiveMode.medium),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarTitle, {
          theme: theme,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "ms-tenantName",
            children: tenantName
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        className: (0, _react.css)(title),
        hidden: titleHidden,
        fill: !(!hideSearch && enableExtendedSearch) && responsiveMode <= _withResponsiveMode.ResponsiveMode.small,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarButton, {
          theme: theme,
          className: responsiveMode <= _withResponsiveMode.ResponsiveMode.small ? titleSmall : '',
          href: appTitleUrl || '#',
          menuProps: selfAppSuiteItems,
          children: appTitle
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        className: (0, _react.css)(!enableExtendedSearch && search, enableExtendedSearch && extendedSearch, modal && modalSearch),
        hidden: hideSearch,
        fill: !hideSearch && enableExtendedSearch,
        children: enableExtendedSearch ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExtendedSearchBox.ExtendedSearchBox, {
          disabled: !searchContext,
          personaPills: personaPills,
          searchText: props.searchTerm,
          isSearchBoxExpanded: isSearchBoxExpanded,
          isFocusInSearch: state.isFocusInSearch,
          backButtonTitle: backButtonLabel,
          searchPlaceholderText: searchPlaceholderText,
          executeSearchLabel: executeSearchLabel,
          removePersonaButtonAriaLabel: props.removePersonaButtonAriaLabel,
          suggestionsSet: props.suggestionsSet,
          filterItems: filterItems,
          selectedFilterKey: selectedFilterKey,
          showFiltersMenu: showFiltersMenu,
          showFiltersIcon: showFiltersIcon,
          onBackClick: _goSearchBack,
          onBlurred: _onSearchBlurred,
          onFocused: _onSearchFocused,
          onFilterClick: props.onFilterClick,
          onChange: _onExtendedSearchChange,
          onSearch: _onSearch,
          toggleSaveSearch: toggleSaveSearch,
          setSelectedSuggestionIndex: setSelectedSuggestionIndex,
          setSearchTextForSuggestion: setSearchTextForSuggestion,
          selectSuggestionByIndex: selectSuggestionByIndex,
          addKeywordSuggestion: addKeywordSuggestion,
          selectedSuggestionIndex: selectedSuggestionIndex,
          addPerson: props.addPersona,
          removePersona: props.removePersona,
          selectFilterItem: props.selectFilterItem,
          hideFilter: props.hideFilter
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchBox.SearchBox, {
          disabled: !searchContext,
          value: props.searchTerm,
          onChange: _onSearchChange
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
        hidden: modal || !hideSearch && enableExtendedSearch || responsiveMode <= _withResponsiveMode.ResponsiveMode.small,
        fill: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.FocusZone, {
        className: section,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: searchVisible !== true || modal || responsiveMode > _withResponsiveMode.ResponsiveMode.large,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            "data-automation-id": "showSearch",
            title: showSearchButtonLabel,
            onClick: _showSearch,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Search'
            })
          })
        }), waffleVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: modal || responsiveMode >= _withResponsiveMode.ResponsiveMode.xLarge || responsiveMode < _withResponsiveMode.ResponsiveMode.medium,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            checked: state.isWaffleOpen,
            onClick: _onWaffleClick,
            title: waffleLabel,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'WaffleOffice365'
            })
          })
        }) : null, optionsVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: modal || responsiveMode < _withResponsiveMode.ResponsiveMode.medium,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            onClick: onOptionsClick,
            checked: isOptionsOpen,
            title: optionsLabel,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Settings'
            })
          })
        }) : null, helpVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: modal || responsiveMode < _withResponsiveMode.ResponsiveMode.medium,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            onClick: onHelpClick,
            checked: isHelpOpen,
            title: helpLabel,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Help'
            })
          })
        }) : null, notificationsVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: modal || responsiveMode < _withResponsiveMode.ResponsiveMode.medium,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            title: notificationsLabel,
            onClick: onNotificationPanelClick,
            checked: isNotificationPanelOpen,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Ringer'
            })
          })
        }) : null, tenantPickerVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: modal || responsiveMode < _withResponsiveMode.ResponsiveMode.medium,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            onClick: onTenantPickerClick,
            checked: isTenantPickerOpen,
            title: tenantPickerLabel,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Org'
            })
          })
        }) : null, flagsVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: modal || responsiveMode < _withResponsiveMode.ResponsiveMode.medium,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            onClick: onFlagsClick,
            checked: isFlagsOpen,
            title: flagsLabel,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Flag'
            })
          })
        }) : null, meControlVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          hidden: modal || responsiveMode < _withResponsiveMode.ResponsiveMode.medium,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            checked: isMeControlOpen,
            onClick: onMeClick,
            title: meControlLabel,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "ms-AppBarButton",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Persona.Persona, {
                imageUrl: myAvatarUrl,
                size: _Persona.PersonaSize.extraSmall
              })
            })
          })
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarGroup, {
          className: overflow,
          hidden: modal || responsiveMode > _withResponsiveMode.ResponsiveMode.small,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.AppBarIconButton, {
            theme: theme,
            onRenderMenuIcon: function onRenderMenuIcon() {
              return null;
            },
            menuProps: {
              coverTarget: true,
              isBeakVisible: false,
              items: _getOverflowItems()
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'MoreVertical'
            })
          })
        })]
      })]
    }), waffleVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_WafflePanel.WafflePanel, {
      isOpen: state.isWaffleOpen,
      items: appSuiteItems,
      headerText: waffleHeaderText !== null && waffleHeaderText !== void 0 ? waffleHeaderText : '',
      onDismiss: _onWaffleDismiss,
      panelType: responsiveMode < _withResponsiveMode.ResponsiveMode.xLarge ? _Panel.PanelType.smallFixedFar : _Panel.PanelType.smallFixedNear
    }) : null]
  });
};

exports.StandardAppBar = StandardAppBar;